"use client";

import React from 'react';
import { useTranslation } from 'react-i18next';
import { CheckCircle2, XCircle } from 'lucide-react';

export const Comparison = () => {
  const { t } = useTranslation();

  return (
    <section id="advantages" className="py-20 bg-gradient-to-br from-blue-600/30 to-purple-700/30">
      <div className="container mx-auto px-4">
        <h2 className="text-4xl font-bold text-center mb-12 text-gradient text-glow">{t('comparison.title')}</h2>
        
        <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto">
          <div className="bg-white/10 backdrop-blur-sm p-8 rounded-xl border border-white/10">
            <h3 className="text-2xl font-bold text-white mb-6">{t('comparison.myApproach')}</h3>
            <ul className="space-y-4">
              {[1, 2, 3, 4, 5].map((i) => (
                <li key={i} className="flex items-start space-x-3">
                  <CheckCircle2 className="w-6 h-6 text-blue-300 flex-shrink-0 mt-1" />
                  <span className="text-blue-100">{t(`comparison.advantages.${i}`)}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="bg-white/5 backdrop-blur-sm p-8 rounded-xl border border-white/10">
            <h3 className="text-2xl font-bold text-white/80 mb-6">{t('comparison.competition')}</h3>
            <ul className="space-y-4">
              {[1, 2, 3, 4, 5].map((i) => (
                <li key={i} className="flex items-start space-x-3">
                  <XCircle className="w-6 h-6 text-purple-300 flex-shrink-0 mt-1" />
                  <span className="text-blue-100/80">{t(`comparison.disadvantages.${i}`)}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};